namespace RedBullMOBILE360.AutomaticReports {
    export class MonitorAlertColumns {
        static columnsKey = 'AutomaticReports.MonitorAlert';
    }
}